import * as crypto from 'crypto';
import { decodeData, decryptResponse } from './http-server';
import { HandleRefreshToken } from '@/app/actions/refresh-token';
import { notify } from '@/utils/funtion';

class FetchClient {
  private static _instance: FetchClient;
  private baseUrl: string;
  private secetKey: string;
  private onUnauthorized: (() => void) | null = null;

  constructor() {
    this.baseUrl = process.env.NEXT_PUBLIC_API_URL ?? '';
    this.secetKey = process.env.NEXT_PUBLIC_SECRET_KEY ?? '';
  }

  static getInstance(): FetchClient {
    if (!FetchClient._instance) {
      FetchClient._instance = new FetchClient();
    }
    return FetchClient._instance;
  }

  public decryptResponse(encryptedResponse: string) {
    const [ivHex, encryptedHex] = encryptedResponse?.split(':');

    const ivBuffer = Buffer.from(ivHex, 'hex');
    const secretKey = process.env.NEXT_PUBLIC_SECRET_KEY || '';

    const decipher = (crypto as any).createDecipheriv(
      'aes-256-cbc',
      Buffer.from(secretKey),
      ivBuffer,
    );

    let decrypted = decipher.update(encryptedHex, 'hex', 'utf-8');
    decrypted += decipher.final('utf-8');
    return JSON.parse(decrypted);
  }

  async fetchWithAuth(
    url: string,
    options: RequestInit,
    retryCount = 0,
  ): Promise<any> {
    console.log('🚀 ~ FetchClient ~ options:', options);
    const accessToken = localStorage.getItem('accessToken');
    const decode: any = await decodeData(accessToken || '');

    const authHeaders: Record<string, string> = decode?.accessToken
      ? {
          Authorization: `Bearer ${decode?.accessToken || ''}`,
        }
      : {};

    const config: RequestInit = {
      ...options,
      headers: {
        ...options.headers,
        ...authHeaders,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const response = await fetch(url, config);
    const result = await response.json();

    if (response.status === 401) {
      return {
        status: false,
        key: 'unauthorized',
        mesage: 'Không có quyền truy cập',
      };
    }

    if (!result?.data) {
      return result;
    }

    const data = await this.decryptResponse(result?.data);
    return { ...result, data };
  }

  async getMethod(
    path: string,
    params?: Record<string, any>,
    options?: RequestInit,
  ): Promise<any> {
    try {
      const url = new URL(`${this.baseUrl}${path}`);
      if (params) {
        Object.keys(params).forEach((key) =>
          url.searchParams.append(key, params[key]),
        );
      }
      const response = await this.fetchWithAuth(url.href, {
        method: 'GET',
        ...options,
      });
      return response;
    } catch (error) {
      console.error('FetchClient -> getMethod -> error:', error);
    }
  }

  async postMethod(
    path: string,
    body?: Record<string, any> | FormData,
    customHeaders?: Record<string, string>,
  ): Promise<any> {
    const headers = {
      ...customHeaders,
      ...(body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' }),
    };
    const response = await this.fetchWithAuth(`${this.baseUrl}${path}`, {
      method: 'POST',
      body: body instanceof FormData ? body : JSON.stringify(body),
      headers: headers as any,
    });
    return response;
  }

  async putMethod(path: string, body?: Record<string, any>): Promise<any> {
    const response = await this.fetchWithAuth(`${this.baseUrl}${path}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
    });
    return response;
  }

  async deleteMethod(path: string, params?: Record<string, any>): Promise<any> {
    const url = new URL(`${this.baseUrl}${path}`);
    if (params) {
      Object.keys(params).forEach((key) =>
        url.searchParams.append(key, params[key]),
      );
    }
    const response = await this.fetchWithAuth(url.href, { method: 'DELETE' });
    return response;
  }
}

export default FetchClient.getInstance();
